import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";

const formatDay = (isoDate) => format(parseISO(isoDate), "d MMM", { locale: es });

export const formatDayRange = (start, end) => `${formatDay(start)} – ${formatDay(end)}`;

export const formatComparedPeriod = (period) =>
  `${formatDayRange(period.start_date, period.end_date)} · comparado con ${formatDayRange(
    period.previous_start_date,
    period.previous_end_date
  )}`;

export const KPI_GRID_SX = {
  display: "grid",
  gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))" },
  gap: 1.5,
};

export const SURFACE_SX = { p: "16px 20px", gap: 1.5 };

/** Integration block that is connected and answered without error. */
/** Connected and without error; an empty or missing block has no data. */
export const hasData = (block) => Boolean(block?.connected) && !block.error;

export const sumTasks = (project, field) => project.phases.reduce((total, phase) => total + phase[field], 0);

/** Projects that moved during the period: with progress or with tasks in it. */
export const projectsWithActivity = (projectsData) =>
  (projectsData.projects || []).filter(
    (project) => project.progress_percentage || project.phases.some((phase) => phase.tasks.length > 0)
  );

export const reportsBasePath = (role) => (role === "client" ? "/informes" : "/HerramientasIA/informes");

export const REPORT_STATUS_BADGES = {
  generated: { label: "Revisión", color: "yellow" },
  approved: { label: "Enviado", color: "green" },
};
